
import { defineComponent, ref, watch, onMounted, computed } from "vue";
import { useStore } from "vuex";
import { useRouter } from "vue-router";
import Swal from "sweetalert2/dist/sweetalert2.min.js";
import {
  setCurrentPageBreadcrumbs,
  setCurrentPageTitle,
} from "@/core/helpers/breadcrumb";
import { MenuComponent } from "@/assets/ts/components";
import AppService, {
  renderImageUrl,
  refreshSelectMedia,
  getConfigs,
  showSingleMedia,
  renderImageUrlEditor,
  findItemArrayChildren,
} from "@/core/services/AppService";
import Editor from "@tinymce/tinymce-vue";
import { getTinymce } from "@tinymce/tinymce-vue/lib/cjs/main/ts/TinyMCE";
import { News, NewsDefault } from "@/store/model/News";
import { Actions } from "@/store/enums/StoreEnums";

export default defineComponent({
  name: "edit-news",
  props: ["id"],
  components: { editor: Editor },
  setup(props) {
    const image_editor = ref();

    const editorConfig = {
      image_advtab: true,
      image_caption: true,
      image_description: true,
      image_uploadtab: true,
      image_class_list: [
        { title: "None", value: "" },
        { title: "No border", value: "img_no_border" },
        { title: "Green border", value: "img_green_border" },
        { title: "Blue border", value: "img_blue_border" },
        { title: "Red border", value: "img_red_border" },
      ],
      height: 1200,
      menubar: true,
      file_picker_callback: function (callback, value, meta) {
        let x =
          window.innerWidth ||
          document.documentElement.clientWidth ||
          document.getElementsByTagName("body")[0].clientWidth;
        let y =
          window.innerHeight ||
          document.documentElement.clientHeight ||
          document.getElementsByTagName("body")[0].clientHeight;

        let url = "/manager-media?type=editor";
        const instanceApi = getTinymce().activeEditor.windowManager.openUrl({
          url: url,
          title: "Quản lý media",
          width: x * 0.8,
          height: y * 0.95,
          onMessage: (api, message) => {
            //console.log("message", message, api);
            api.close();
          },
          onClose: async (instance, trigger) => {
            let dataImage = JSON.parse(image_editor.value);
            //console.log(dataImage);
            let image = renderImageUrlEditor(dataImage);
            let width = dataImage.width ? dataImage.width : "800";
            if (width > 1200) width = 1000;
            callback(image, {
              text: dataImage["path"],
              alt: dataImage["originalname"],
              width: width.toString(),
              height: "auto",
            });
          },
          onAction: function (instance, trigger) {
            // code for when "custom" buttons are triggered
            //console.log("instance", instance, trigger);
          },
        });
      },
      plugins: [
        "advlist autolink lists link charmap",
        "searchreplace visualblocks code fullscreen",
        "print preview anchor insertdatetime media image",
        "paste code  wordcount table advtable",
      ],
      image_list: [
        { title: "Cat", value: "cat.png" },
        { title: "Dog", value: "dog.jpg" },
      ],
      toolbar:
        "insertfile  |formatselect | bold italic strikethrough underline |backcolor  color | subscript superscript |   alignleft aligncenter alignright alignjustify |  outdent  indent  anchor undo redo | lists   bullist numlist outdent indent | table |image|code|fullscreen",
    };
    const store = useStore();
    const router = useRouter();
    const formRef = ref<null | HTMLFormElement>(null);
    const loading = ref<boolean>(false);
    const listDataNewsCategory = ref([]);
    const category = ref();
    let objectData = ref<News>(JSON.parse(JSON.stringify(NewsDefault)) as News);
    const showPositionCareer = ref<boolean>(false);
    const listDataPositionCareer = ref([]);
    const listDataLocationCareer = ref([]);

    onMounted(async () => {
      await store.dispatch("GET_NEWS_DETAIL", props.id);
      getConfigs("position_career").then((data: any) => {
        listDataPositionCareer.value = data.position_career;
      });
      getConfigs("location_career").then((data: any) => {
        listDataLocationCareer.value = data.location_career;
      });

      await store.dispatch(
        Actions.GET_ALL_NEWS_CATEGORY,
        '?search={"type":"news"}'
      );
      listDataNewsCategory.value = await store.getters["listDataCategory"];

      objectData.value = await store.getters["currentNews"];
      console.log(objectData.value.data_info);
      if (
        objectData.value.categories.includes("622977cc4263000088013324") &&
        objectData.value.data_info === undefined
      ) {
        objectData.value.email_contact =''
        objectData.value.phone_contact =''
        objectData.value.address_work =''
        objectData.value.data_info = {
          experience: "",
          probationary_period: "",
          salary: "",
          level: "",
          working_time: "",
          vacancy: "",
          number: 0,
          age: "",
          sex: "",
          qualification: "",
          expiry_date: "",
        };
      }
      let idC: any = objectData.value.categories[0];
      console.log(idC);
      // category.value =  listDataNewsCategory.value.find(i => i['_id'] == idC);
      category.value = findItemArrayChildren(listDataNewsCategory.value, idC);
      setCurrentPageTitle("Chỉnh sửa tin tức");
      setCurrentPageBreadcrumbs("Chỉnh sửa bài viết", ["Tin tức"]);

      MenuComponent.reinitialization();
    });
    const rules = ref({
      name: [
        {
          required: true,
          message: "Tiêu đề không được để trống",
          trigger: "blur",
        },
      ],
    });
    const isMultipleMedia = computed(() => store.getters["getIsMultiple"]);
    const media_actions = ref(["thumbnail"]);
    watch(
      () => store.state.MediaModule.actionCallback,
      (action: any, second) => {
        if (media_actions.value.includes(action)) {
          if (isMultipleMedia.value) {
            objectData.value[action] = objectData.value[action].concat(
              store.getters["getSelectMultiMedia"]
            );
          } else {
            objectData.value[action] = store.getters["getSelectMedia"];
          }
          refreshSelectMedia();
        }
      }
    );
    const convertNameToSlug = () => {
      objectData.value.slug = AppService.convertSlug(objectData.value.slug);
    };
    watch(
      () => objectData.value.categories,
      (oldData: any, newData) => {
        if (oldData.length > 0) {
          let idC: any = oldData[0];
          category.value = findItemArrayChildren(
            listDataNewsCategory.value,
            idC
          );
        } else category.value = null;
        if (oldData.includes("622977cc4263000088013324")) {
          showPositionCareer.value = true;
        } else {
          showPositionCareer.value = false;
          objectData.value.position_career = "";
        }
      }
    );
    watch(
      () => store.state.MediaModule.actionCallback,
      (action, second) => {
        if (action == "image_news") {
          objectData.value.thumbnail = store.getters["getSelectMedia"];
          refreshSelectMedia();
        }
      }
    );
    const submit = () => {
      if (!formRef.value) {
        return;
      }

      formRef.value.validate((valid) => {
        if (valid) {
          loading.value = false;
          store
            .dispatch("UPDATE_NEWS", objectData.value)
            .then(() => {
              Swal.fire({
                text: "Cập nhật thông tin thành công",
                icon: "success",
                buttonsStyling: false,
                showCancelButton: true,
                confirmButtonText: "Danh sách",
                cancelButtonText: "Tiếp tục chỉnh sửa",
                customClass: {
                  confirmButton: "btn fw-bold btn-light-success",
                  cancelButton: "btn fw-bold btn-light-primary",
                },
              }).then(function (result) {
                // Go to page after successfully login
                if (result.isConfirmed) {
                  router.push({ name: "news" });
                }
              });
            })
            .catch(() => {
              loading.value = false;
              Swal.fire({
                text: store.getters.getErrors,
                icon: "error",
                buttonsStyling: false,
                confirmButtonText: "Thử lại!",
                customClass: {
                  confirmButton: "btn fw-bold btn-light-danger",
                },
              });
            });
        } else {
          return false;
        }
      });
    };
    const domain_FE = process.env.VUE_APP_HOME_FE;
    return {
      rules,
      submit,
      domain_FE,
      editorConfig,
      convertNameToSlug,
      renderImageUrl,
      showSingleMedia,
      loading,
      category,
      showPositionCareer,
      objectData,
      listDataNewsCategory,
      listDataPositionCareer,
      listDataLocationCareer,
      formRef,
      image_editor,
    };
  },
  mounted() {
    //Event Listener for Iframe
    window.addEventListener("message", this.iframeEvent, false);
  },
  methods: {
    iframeEvent(event) {
      //Verify App Domain
      if (event.data.action == "editor") {
        this.image_editor = event.data.image;
      }
    },
  },
});
